export default {
	methods: {
		openGlobalAlert: function (message, color) {
			this.$store.commit('showGlobalAlert', {
				value: true,
				message: message,
				color: color
			})
		},
		openGlobalLoader: function (message) {
			this.$store.commit('showGlobalLoader', {
				value: true,
				message: message
			})
		},
		closeGlobalLoader: function () {
			this.$store.commit('showGlobalLoader', {
				value: false,
				message: ''
			})
		},
		getTranslate: function (key) {
			return this.$t(key)
		},
		checkResponse: function (response) {
			if (response.data.status == "ERROR") {
				return false;
			}
			return true;
		}
	}
}